import { nodeListToArray } from '../helpers/nodeListToArray';

export class queryToggler {
    container: HTMLElement;
    items: Array<HTMLElement>;

    constructor(container: HTMLElement) {
        this.container = container;
        this.items = nodeListToArray(this.container.querySelectorAll('[data-panel-item]'));
        this.checkForParameter();
    }

    checkForParameter() {
        let urlParams = new URLSearchParams(window.location.search);
        let categoryParam = urlParams.get('openItem');

        if (categoryParam) {
            this.openPanel(categoryParam);
        }
    }

    openPanel(panel) {
        this.items.forEach((item) => {
            // If Accordion
            if (item.classList.contains('accordion-item')) {
                let element = document.getElementById(panel);
                let elementParent = element.parentElement as HTMLElement;

                let parent = item.querySelector('.repeatable-item');
                let child = item.querySelector('.repeatable-content');
                // If parameter matches tab item ID, open accordion item
                if (item.id == element.id) {
                    parent.classList.remove('collapsed')
                    parent.setAttribute('aria-expanded', 'true');
                    child.classList.add('show');
                    // Wait for element to open, then scroll into view
                    setTimeout(() => {
                        element.scrollIntoView();
                    }, 1000);
                }
                // Close all other accordion items
                else {
                    parent.classList.add('collapsed')
                    parent.setAttribute('aria-expanded', 'false');
                    child.classList.remove('show');
                }

            }
            // If Tab
            if (item.classList.contains('tabs-list-item')) {
                let element = document.getElementById(panel);
                let parent = item.querySelector('button');
                // If parameter matches tab item ID, activate tab
                if (item.id == element.id) {
                    parent.removeAttribute('tabindex');
                    parent.setAttribute('aria-selected', 'true');
                    const controls = parent.getAttribute('aria-controls');
                    document.getElementById(controls).removeAttribute('hidden');
                    // Scroll element into view
                    setTimeout(() => {
                        element.scrollIntoView();
                    }, 1000);
                }
                // Deactivate all other tabs
                else {
                    parent.setAttribute('tabindex', '-1');
                    parent.setAttribute('aria-selected', 'false');
                    const controls = parent.getAttribute('aria-controls');
                    document.getElementById(controls).setAttribute('hidden', 'hidden');
                }
            }
        })
    }
}